import {Component, OnInit} from '@angular/core';
import {ImgCommonLayoutComponent} from "../img-common-layout/img-common-layout.component";
import {AttachmentUrlService} from "../../../../services/common/attachment-url.service";
import {TranslationService} from "../../../../services/wrapper/translation.service";
import {BsModalService} from "ngx-bootstrap";
import {NotificationService} from "../../../../services/common/notification.service";
import {MyStorageService} from "../../../../services/common/my-storage.service";

@Component({
    selector: 'app-img-layout33',
    templateUrl: './img-layout33.component.html',
    styleUrls: ['./img-layout33.component.scss']
})
export class ImgLayout33Component extends ImgCommonLayoutComponent implements OnInit {


    constructor(attachmentUrlService: AttachmentUrlService, translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService, myStorageService:MyStorageService) {
        super(attachmentUrlService, translationService, modalService, notificationService, myStorageService);
    }

    ngOnInit(): void {
        this.initImages();
    }
}
